module.exports = __webpack_public_path__ + "img/5_unit.5f344a73.png";